export default "__VITE_ASSET__06859217__"